
<template>
  <!-- 关注/互关 背景色置灰 ，主态不展示关注按钮-->
  <ObButton
    v-if="!relationInfo.hide" 
    :text="relationInfo.type != 3 ? $t(relationInfo.label) : ''"
    :icon="relationInfo.type === 3 ? 'icon-mutual' : ''"
    :callBack="onFollow"
    backgroundColor="var(--theme)"
    :class="`follow ${relationInfo.type >= 2 && 'following'}`" 
  />
</template>
<script setup>
import { ref, watch, getCurrentInstance } from 'vue'
import http from '@/service'
import { $throttle } from '@/utils/lodashFuncs'
import { useRoute } from 'vue-router';
const route = useRoute()
const { proxy } = getCurrentInstance()

const emit = defineEmits(['update:relation', 'change'])

const props = defineProps({
  relation: {
    type: Number,
  },
  uid: {
    type: String,
  },
  followFrom: {
    type: String,
    default: ''
  }
})

let uid = props.uid
let relation = ref(props.relation)
const relationInfo = ref({})


/**
 * @description: 关注状态映射
 * @type 0-无关系 1- 粉丝  2-关注 3-互相关注 4-自己
 */
let relationMap = [{
  type: 0,
  label: 'follow'
}, {
  type: 1,
  label: 'follow'
}, {
  type: 2,
  label: 'following'
}, {
  type: 3,
  label: 'followEach'
}]

// 监听uid变化
watch(() => props.uid, (val) => {
  uid = val
}, {immediate: true, deep: true})

// 监听关注状态
watch(() => props.relation, (val) => { 
  relation.value = val
  relationInfo.value = relationMap.find(i => i.type === val) || {
    type: 0,
    label: 'follow'
  }
}, {immediate: true, deep: true})
// 触发关注/取关
const onFollow = $throttle(async () => {
  const actionType = relationInfo.value.type < 2 ? 'follow' : 'unFollow'
  proxy.$ga(actionType === 'follow' ? 'follow' : 'unfollow', {
    "screen_name": route.name,
    "list_name": props.followFrom,
    "userId": uid,
  })
  try {
    const { code, data, msg} = await http[actionType]({ uid })
    if (code === 200 && data) {
      // 修改关注状态，粉丝1==>互关3  关注2==>无关系0  互关3==>粉丝1  无关系0==>关注2
      let updateRelation = 0
      switch (relationInfo.value.type) {
        case 1:
          updateRelation = 3
          break
        case 2:
          updateRelation = 0
          break
        case 3:
          updateRelation = 1
          break
        default:
          updateRelation = 2
      }
      // 双向绑定值更新
      emit('update:relation', updateRelation)
      // 父组件触发
      emit('change', {
        uid,
        relation: updateRelation
      })
      proxy.$toast({
        message: `${proxy.$t(actionType)} ${proxy.$t('success')}`
      })
    }
  } catch (e) {
  }
}, 2000)

</script>
<style lang="postcss" scoped>
  .ob-button {
    --el-button-hover-bg-color: var(--theme) !important; 
    --el-button-active-bg-color: var(--theme-background) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    min-width: 68px;
    height: 36px !important;
    color: #FFF;
    border: none;
    cursor: pointer;
    padding: 0 16px;
    width: auto !important;
    font-size: 14px;
  }
  .following {
    background: var(--background-hint);
    color: #FFF;
    border-radius: var(--button-radius) !important;
  }

  @media screen and (max-width: 1023px) {
    button {
      min-width: 63px;
      height: 28px !important;
      font-size: 12px;
      line-height: 20px;
      padding: 0 12px;
    }
  }
</style>